import { Component } from '@angular/core';

@Component({
  selector: 'uni-list-footer',
  templateUrl: './uni-list-footer.component.html',
  styleUrls: ['./uni-list-footer.component.scss'],
})
export class UniListFooterComponent {}
